import { Injectable, OnDestroy } from '@angular/core';
import { AbstractFacade } from 'app/modules/dashboard/facades/abstract.facade';
import { FacadesRegistry } from 'app/modules/dashboard/facades/facades.registry';
import { Timer } from 'app/types/timer';

// Default delay for each cycle in ms
const DEFAULT_DELAY_FOR_CHECK_CYCLE = 60000;

type DestroyableFacade = AbstractFacade & OnDestroy;

@Injectable({
  providedIn: 'root',
})
export class GlobalCacheManager {
  private timerCycleInterval: Timer;
  constructor(
    private readonly facadesRegistry: FacadesRegistry
  ) {}

  start() {
    this.timerCycleInterval = setInterval(() => {
      this.checkFacadeToDestroy();
    }, DEFAULT_DELAY_FOR_CHECK_CYCLE);
  }

  stop() {
    if (this.timerCycleInterval) {
      clearInterval(this.timerCycleInterval);
    }
  }

  private checkFacadeToDestroy() {
    const facadesInfoEntries = this.facadesRegistry.getAllEntries();
    const currentTime = new Date().getTime();
    for (const [key, accessInfo] of facadesInfoEntries) {
      const { lastAccess, ttl, facade } = accessInfo;
      if (!facade.store.observed && (lastAccess + ttl) < currentTime) {
        (facade as DestroyableFacade)?.ngOnDestroy?.();
        this.facadesRegistry.remove(key);
      }
    }
  }
}
